import {Slider, styled} from '@mui/material'

export const RatingSlider = styled(Slider)(({ theme, ownerState }) => {
    const getColor = () => {
        if (ownerState.value <= 4) return "#ffa2a2";
        if (ownerState.value >= 8) return "#a0df9e";
        return "#ffc484";
    };

    return {
        height: 4,
        "& .MuiSlider-track": {
            backgroundColor: getColor(),
            border: "none",
        },
        "& .MuiSlider-rail": {
            opacity: 0.3,
            backgroundColor: "#cdcdcd",
        },
        "& .MuiSlider-thumb": {
            width: 28,
            height: 28,
            backgroundColor: "#fff",
            "&:hover": {
                boxShadow: "0 0 0 8px rgba(0,0,0,0.08)",
            },
            boxShadow: '0 0 2px 0px rgba(0, 0, 0, 0.1)',
            '&:focus, &:hover, &.Mui-active': {
                boxShadow: '0px 0px 3px 1px rgba(0, 0, 0, 0.1)',
                '@media (hover: none)': {
                    boxShadow: '0 3px 1px rgba(0,0,0,0.1),0 4px 8px rgba(0,0,0,0.13),0 0 0 1px rgba(0,0,0,0.02)',
                },
            },
            '&:before': {
                boxShadow:
                    '0px 0px 1px 0px rgba(0,0,0,0.2), 0px 0px 0px 0px rgba(0,0,0,0.14), 0px 0px 1px 0px rgba(0,0,0,0.12)',
            },
        },
        "& .MuiSlider-valueLabel": {
            top: 55,
            borderRadius: 6,
            backgroundColor: 'unset',
            '& .MuiSlider-valueLabelLabel': {
                color: '#000000',
                fontSize: 16,

            },
        },
    };
});